// this function returns true if the event has a key code
// for tab, shift, or an arrow key
export function specialKey($event) {
  var keyCode = $event.keyCode;
  if (keyCode == 9 || keyCode == 16 || keyCode == 19 || keyCode == 37 || keyCode == 38 || keyCode == 39 || keyCode == 40) {
    return true;
  }
}

export function isSameAddress(addressOne, addressTwo, extraFields) {
  // If addressOne fields different from addressTwo set flag false
  var keys = ['first_name', 'last_name', 'street_1', 'street_2', 'post_code', 'city', 'region'];
  if (extraFields && Array.isArray(extraFields)) {
    keys = [...keys, ...extraFields];
  }

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if ((addressOne[key] || '').toLowerCase() != (addressTwo[key] || '').toLowerCase()) {
      return false;
    }
  }

  return true;
}

export function paymentProfileClass(paymentGateway, ccType) {
  let pClass = 'card-logo';

  function createClass(string) {
    return `${string.toLowerCase().replace(/\s/g,'')}-logo-svg`;
  }

  if (paymentGateway == 'braintree' && ccType && ccType.length) {
    pClass = createClass(ccType);
  } else if (paymentGateway) {
    pClass = createClass(paymentGateway);
  }

  return pClass;
}

export function getShortDateString(date) {
  date = new Date(date);
  var m = ('0' + (date.getMonth() + 1)).substr(-2);
  var d = ('0' + date.getDate()).substr(-2);

  return date.getFullYear() + '-' + m + '-' + d;
}

export function shuffleArray(array) {
  if (array && Array.isArray(array)) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }
}

export function isNum(value) {
  return (typeof value === 'number' || (typeof value === 'string' && /^[0-9,.]+$/.test(value)) || value instanceof Number);
}

/**
 Simple copy of an object
 **/
export function deepCopyObj(obj) {
  var theCopy = {};
  var val;

  Object.keys(obj).forEach(function(key) {
    val = obj[key];
    if (isObject(val)) {
      theCopy[key] = deepCopyObj(val);
    } else if (Array.isArray(val)) {
      theCopy[key] = copyArray(val);
    } else {
      theCopy[key] = val;
    }
  });

  return theCopy;
}

export function isObject(theThing) {
  return Object.prototype.toString.call(theThing) === '[object Object]';
}

/**
 * Copies an array, not deep
 * @param  {Array} arr The array to copy
 * @return {Array}     The copied array
 */
export function copyArray(arr) {
  var i = 0;
  var l = arr.length;
  var newArr = [];

  for (; i < l; i++) {
    newArr[i] = Array.isArray(arr[i]) ? copyArray(arr[i]) :
      toString.call(arr[i]) === '[object Object]' ? deepCopyObj(arr[i]) :
        arr[i];
  }

  return newArr;
}

export function getObjProperty() {
  var obj = Array.prototype.shift.call(arguments);
  return safeGetProperty.apply(obj, arguments);
}

function safeGetProperty() {
  /* jshint validthis:true */
  var args = Array.prototype.map.call(arguments, function(arg) {
    return ('' + arg).split('.');
  });

  var all = Array.prototype.concat.apply([], args);

  var key = all.shift();
  let remainingKeys = [...all];
  var prop = (this || {})[key];

  // If the property is undefined but we have more keys, maybe there's a . in those keys...
  // keep trying until we run out of keys or find a property that matches
  while (remainingKeys.length && prop === undefined) {
    key += '.' + remainingKeys.shift();
    prop = (this || {})[key];
  }
  all = remainingKeys;

  if (prop === undefined || !all.length) {
    return prop;
  }

  return safeGetProperty.apply(prop, all);
}
